// import { useLocation, useNavigate } from "react-router-dom";
// import "../styles/floatingShopNow.css";

// const FloatingShopNow = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Hide from admin pages
//   if (location.pathname.startsWith("/admin")) {
//     return null;
//   }

//   return (
//     <button
//       type="button"
//       className="floating-shop-now"
//       onClick={() => navigate("/hardware")}
//       aria-label="Shop now"
//       title="Shop Now"
//     >
//       <img src="/images/shop-now-lyrazone-lyra-zone.png" alt="Shop Now" />
//     </button>
//   );
// };

// export default FloatingShopNow;

import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/floatingShopNow.css";

const FloatingShopNow = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    setIsVisible(true);
  }, [location.pathname]);

  const hiddenPaths = [
    "/admin",
    "/hardware",
    "/subproducts",
    "/singleproduct",
    "/shopping-cart",
    "/checkout",
  ];

  const shouldHideByPath = hiddenPaths.some((path) =>
    location.pathname.startsWith(path),
  );

  if (!isVisible || shouldHideByPath) {
    return null;
  }

  return (
    <div className="floating-shop-now-wrap">
      <button
        type="button"
        className="floating-shop-now-close"
        onClick={() => setIsVisible(false)}
        aria-label="Close shop now floating icon"
        title="Close"
      >
        ×
      </button>

      <button
        type="button"
        className="floating-shop-now"
        onClick={() => navigate("/hardware")}
        aria-label="Shop now"
        title="Shop Now"
      >
        <img src="/images/shop-now-lyrazone-lyra-zone.png" alt="Shop Now" />
      </button>
    </div>
  );
};

export default FloatingShopNow;
